import * as React from 'react';
import {Box, Tooltip, Typography} from "@mui/material";
import {correctName, formatNumber, formatPercentage, getLabelFromNuance, getWidth, tours} from "../../../Utils";

import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import MultipleStopIcon from '@mui/icons-material/MultipleStop';
import HowToVoteIcon from '@mui/icons-material/HowToVote';
export default function BaBarre({data, year, total, dataT1, abstention, total2, title,couleurPolitique}) {

    function checkTour1Tour2() {
        if (dataT1) {

            let t1 = Object.keys(dataT1).sort((a, b) => dataT1[a].nb - dataT1[b].nb).reverse()[0];
            let t2 = Object.keys(data).sort((a, b) => data[a].nb - data[b].nb).reverse()[0];
            return t1 !== t2;
        }
        return false
    }


    function getDiff() {
        let listCandidtas=Object.keys(data).sort((a, b) => data[a].nb - data[b].nb).reverse();
        return data[listCandidtas[0]].nb - data[listCandidtas[1]].nb;
    }

    return (
        <Box sx={{width: '49%', display: "flex", flexDirection: "row", mb: 2}}>
            <Box sx={{width: '100%', display: "flex", flexDirection: "column"}}>
                <Box sx={{width: '100%', display: "flex", flexDirection: "row", mb: 2}}>
                    <Typography variant={"h6"} sx={{
                        fontStyle: "normal",
                        fontWeight: 700,
                        fontSize: 24,
                        color: "#666666"
                    }}>{title}</Typography>
                </Box>


                <Box sx={{width: '100%', display: "flex", flexDirection: "column", mb: 2}}>

                    <Box sx={{
                        boxSizing: "border-box",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        padding: 1,
                        gap: 1,
                        color: "#4c8ed0",
                        background: "#FFFFFF",

                        borderRadius: 2
                    }}>
                        <HowToVoteIcon/>
                        <Typography variant={"body"} sx={{
                            fontStyle: "normal",
                            fontWeight: 400,

                            flex: "none",
                            order: "1",
                            flexGrow: "1",
                            fontSize: {md: "10px", lg: "12px", xl: "16px"},
                            lineHeight: {md: "10px", lg: "12px", xl: "16px"}
                        }}>
                            Abstention : {formatNumber(abstention.nb)} voix ({formatPercentage(abstention.perc)})
                        </Typography>
                    </Box>
                    {!couleurPolitique && Object.keys(data).length>1 && <Box sx={{
                        boxSizing: "border-box",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        padding: 1,
                        gap: 1,
                        color: "#3aae00",
                        background: "#FFFFFF",

                        borderRadius: 2
                    }}>
                        <MultipleStopIcon/>
                        <Typography variant={"body"} sx={{
                            fontStyle: "normal",
                            fontWeight: 400,

                            flex: "none",
                            order: "1",
                            flexGrow: "1",
                            fontSize: {md: "10px", lg: "12px", xl: "16px"},
                            lineHeight: {md: "10px", lg: "12px", xl: "16px"}
                        }}>
                            Ecart entre le vainqueur et le 2° Candidat : {getDiff()} voix
                        </Typography>
                    </Box>}
                    <Box sx={{width: "100%", display: "flex", flexDirection: "row", mt: 2}}>
                        <Box sx={{width: "calc(100% - 100px)", display: "flex", flexDirection: "row"}}>
                            {Object.keys(data).sort((a, b) => data[a].nb - data[b].nb).map((candidat, k) => {
                                let size = getWidth(data[candidat].nb, total);

                                const infoItems = [
                                    correctName(data[candidat].nomPrenom),
                                    "(" + getLabelFromNuance(data[candidat].nuance).name+")",
                                    formatNumber(data[candidat].nb) +" (" + formatPercentage(data[candidat].perc) + ")",

                                ];
                                const tip = infoItems.join('\n')
                                return (
                                        <Tooltip title={
                                            <div style={{whiteSpace: 'pre-line'}}>{tip}</div>
                                        }key={k}>
                                    <Box sx={{
                                        height: 50,
                                        width: size,
                                        display: "flex",
                                        backgroundColor: getLabelFromNuance(data[candidat].nuance).color,
                                        color: "white",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        borderTopRightRadius: k === Object.keys(data).length - 1 ? 25 : 0,
                                        borderBottomRightRadius: k === Object.keys(data).length - 1 ? 25 : 0,
                                        borderStyle: "solid",
                                    }} >
                                            <Typography sx={{
                                                fontSize: "20px",
                                                fontStyle: "normal",
                                                fontWeight: 700,
                                                lineHeight: "24px"
                                            }}>

                                                {data[candidat].perc > 0.1 && formatPercentage(data[candidat].perc)}
                                            </Typography>

                                    </Box></Tooltip>)
                            })}
                        </Box>
                        <Box sx={{
                            width: 100,
                            height: 50,
                            display: "flex",
                            flexDirection: "column",
                            ml: 1,
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <Typography sx={{
                                color: "#666",
                                fontSize: "12px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "normal"
                            }}>
                                {formatNumber(total2)}
                            </Typography>
                            <Typography sx={{
                                color: "#666",
                                fontSize: "10px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "normal"
                            }}>
                                votants
                            </Typography>

                        </Box>
                    </Box>


                    {<Box sx={{width: '100%', display: "flex", flexDirection: "row", flexWrap: "wrap", mt: 2}}>
                        {Object.keys(data).sort((a, b) => data[a].nb - data[b].nb).map((candidat, k) => {

                            if (data[candidat].nomPrenom) {
                                return (
                                    <Box
                                        sx={{
                                            mr: 2,
                                            mb: 2,
                                            display: "flex",
                                            alignItems: "center",
                                            width: "45%",
                                            height: 45
                                        }}
                                        key={k}>
                                        <Box sx={{
                                            height: 45,
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center"
                                        }}>
                                            <Box sx={{
                                                width: 20,
                                                height: 20,
                                                display: "flex",
                                                flexDirection: "column",
                                                mb: 1,
                                                mr: 1,
                                                backgroundColor: getLabelFromNuance(data[candidat].nuance).color,
                                                borderRadius: 24
                                            }}></Box>
                                        </Box>
                                        <Box sx={{height: 45}}>


                                            <Tooltip title={correctName(data[candidat].nomPrenom)}>
                                                <Box sx={{display: "flex", flexDirection: "row", flexWrap: "wrap"}}>
                                                    <Typography noWrap={true} sx={{
                                                        height: 18,
                                                        maxWidth: 130,
                                                        color: "#666",
                                                        fontSize: "13px",
                                                        fontStyle: "normal",
                                                        fontWeight: 900,
                                                        lineHeight: "normal",
                                                    }}>{correctName(data[candidat].nomPrenom)} </Typography>
                                                    <Typography sx={{
                                                        height: 18, ml: 1,
                                                        color: "#666",
                                                        fontSize: "13px",
                                                        fontStyle: "normal",
                                                        fontWeight: 400,
                                                        lineHeight: "normal",
                                                    }}> {formatNumber(data[candidat].nb)} ({formatPercentage(data[candidat].perc)})</Typography>
                                                </Box>
                                            </Tooltip>


                                            <Typography noWrap={true} sx={{
                                                height: 18,
                                                maxWidth: 145,
                                                color: "#666",
                                                fontSize: "10px",
                                                fontStyle: "normal",
                                                fontWeight: 400,
                                                lineHeight: "normal",
                                            }}> {getLabelFromNuance(data[candidat].nuance, year).name}</Typography>


                                        </Box>
                                    </Box>)
                            } else {
                                return (

                                    <Box
                                        sx={{
                                            mr: 2,
                                            mb: 2,
                                            display: "flex",
                                            alignItems: "center",
                                            width: "45%",
                                            height: 45
                                        }}
                                        key={k}>
                                        <Box sx={{
                                            height: 45,
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center"
                                        }}>
                                            <Box sx={{
                                                width: 20,
                                                height: 20,
                                                display: "flex",
                                                flexDirection: "column",
                                                mb: 1,
                                                mr: 1,
                                                backgroundColor: getLabelFromNuance(data[candidat].nuance).color,
                                                borderRadius: 24
                                            }}></Box>
                                        </Box>
                                        <Box sx={{height: 45}}>


                                            <Tooltip title={correctName(data[candidat].nuance)}>
                                                <Box sx={{display: "flex", flexDirection: "row", flexWrap: "wrap"}}>
                                                    <Typography noWrap={true} sx={{
                                                        height: 18,
                                                        maxWidth: 130,
                                                        color: "#666",
                                                        fontSize: "13px",
                                                        fontStyle: "normal",
                                                        fontWeight: 900,
                                                        lineHeight: "normal",
                                                    }}>{correctName(data[candidat].nuance)} </Typography>
                                                    <Typography sx={{
                                                        height: 18, ml: 1,
                                                        color: "#666",
                                                        fontSize: "13px",
                                                        fontStyle: "normal",
                                                        fontWeight: 400,
                                                        lineHeight: "normal",
                                                    }}> {formatNumber(data[candidat].nb)} ({formatPercentage(data[candidat].perc)})</Typography>
                                                </Box>
                                            </Tooltip>


                                            <Typography noWrap={true} sx={{
                                                height: 18,
                                                maxWidth: 145,
                                                color: "#666",
                                                fontSize: "10px",
                                                fontStyle: "normal",
                                                fontWeight: 400,
                                                lineHeight: "normal",
                                            }}> {getLabelFromNuance(data[candidat].nuance, year).name}</Typography>


                                        </Box>
                                    </Box>)
                            }
                        })}
                    </Box>}
                </Box>

                {checkTour1Tour2() && <Box sx={{
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    padding: 1,
                    mt:2,
                    gap: 1,
                    background: "#FFFFFF",
                    border: "1px solid #f40a06",
                    borderRadius: 2,
                    color: "#f40a06",
                }}>
                    <InfoOutlineIcon/>
                    <Typography variant={"body"} sx={{
                        fontStyle: "normal",
                        fontWeight: 400,

                        flex: "none",
                        order: "1",
                        flexGrow: "1",
                        fontSize: {md: "10px", lg: "12px", xl: "16px"},
                        lineHeight: {md: "10px", lg: "12px", xl: "16px"}
                    }}>
                        Vainqueur du second tour différent du vainqueur du premier tour
                    </Typography>
                </Box>}
            </Box>
        </Box>
    );
}
